let gradeList = ['小学一年级', '小学二年级', '小学三年级', '小学四年级', '小学五年级', '小学六年级', '初中一年级', '初中二年级', '初中三年级', '高中一年级', '高中二年级', '高中三年级', '大学一年级', '大学二年级', '大学三年级', '大学四年级']
let gradeListSimple = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一年级', '初二年级', '初三年级', '高一年级', '高二年级', '高三年级', '大学一年级', '大学二年级', '大学三年级', '大学四年级']

export default (index) => {
  return {
    tableGrade: gradeList[index - 1], // 表格中1-16转化为年级 字符串
    gradeListSimple: gradeListSimple[index - 1]
  }
}
